﻿<template>
    <div class="bd-trip">
        <h4 class="bd-trip-name">{{trip?.tour_name}}</h4>
        <div class="bd-trip-date" v-if="Departure_Date()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
            </svg>
            Departs {{Departure_Date()}}
        </div>

        <div class="bd-trip-table-wrap">
            <table class="bd-trip-table">
                <thead>
                    <tr>
                        <th>Guest</th>
                        <th class="bd-num">Commission</th>
                        <th class="bd-num">Price</th>
                        <th class="bd-center">Cancel</th>
                    </tr>
                </thead>
                <tbody>
                    <booking_line_passenger :trip_passenger="trip_passenger" v-for="(trip_passenger, index) in trip?.passengers" :key="index"></booking_line_passenger>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" src="./booking_line.ts"></script>